import { LoanResortsService } from './../../services/loan-resorts.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AngularCsv } from 'angular7-csv/dist/Angular-csv';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
import { AuthService } from 'app/services/auth.service';
import { ToastrService } from 'ngx-toastr';

declare var $: any;
@Component({
  selector: 'app-cpa-report-tat',
  templateUrl: './cpa-report-tat.component.html',
  styleUrls: ['./cpa-report-tat.component.css'],
})
export class CpaReportTatComponent implements OnInit {
  user: any;
  p: number = 1;
  itemsPerPage = 10;
  currentPage = 1;
  // lApplications: any;
  dataToShow: any;
  filterWnameArr: any;
  dataRec: boolean;
  fromDate: any;
  toDate: any;
  loanAppsLoaded: Boolean = false;
  valMsgRS: Boolean = false;

  constructor(
    private lservice: LoanResortsService,
    private router: Router,
    private auth: AuthService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.getProfile();
    this.loanAppsLoaded = true;
    let filter = {
      fromDate: '2019-01-01',
      toDate: '2020-04-08',
    };
    this.cpaTatReportByDateRange(filter);
  }

  cpaTatReportByDateRange(filter) {
    this.loanAppsLoaded = false;
    this.lservice.cpaTatReport(filter).subscribe((data) => {
      this.loanAppsLoaded = true;
      this.dataRec = true;
      if (data['success']) {
        this.dataToShow = data['data'];
      } else {
        this.toastr.error('Something went wrong, please try again.');
      }
    });
  }

  getProfile() {
    this.loanAppsLoaded = false;
    this.auth.getProfile().subscribe(
      (profile) => {
        this.loanAppsLoaded = true;
        this.user = profile['user'];
        if (this.user['profileCompleted'] == 'false') {
          this.router.navigateByUrl('/completeprofile');
        } else {
          if (this.user['accountStatus'] == 'inactive') {
            this.router.navigateByUrl('/completeprofile');
          } else {
            console.log('All done');
          }
        }
      },
      (err) => {
        this.router.navigateByUrl('/login');
        console.log(err);
        this.toastr.error('Something went wrong. Please try again.');
        this.loanAppsLoaded = true;
        return false;
      }
    );
  }

  isInArray(value, array) {
    return array.indexOf(value) > -1;
  }
  filterByDate() {
    let filter = {
      fromDate: this.fromDate,
      toDate: this.toDate,
    };
    this.cpaTatReportByDateRange(filter);
  }
}
